/**
 * What `PushSubscriptionSync` has already written, for this page load.
 *
 * IN ITS OWN `.ts` FILE, away from the component: a module that exports both a component and a
 * plain function loses fast refresh — React's plugin cannot tell which half changed — and the repo
 * treats that warning as an error (see `features/auth/components/tenant-choice.ts`, same reason).
 *
 * Only SUCCESSES are recorded. A reconcile that failed is not remembered, so the next mount tries
 * again; a repeat after a success would be a write nobody asked for.
 */

const reconciled = new Set<string>();

export function isPushReconciled(tenantId: string): boolean {
  return reconciled.has(tenantId);
}

export function markPushReconciled(tenantId: string): void {
  reconciled.add(tenantId);
}

/** Test seam: forget this page's writes. */
export function resetPushSync(): void {
  reconciled.clear();
}
